import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useInfiniteScrollQuery } from 'hooks'

import { selectCallTimelineFilters } from 'store/selectors'

import { CALL_TIMELINE_TYPE } from 'features/CallTimeline/CallTimeline'
import { useFavFilterGrowthBookEnabled } from 'features/FeatureFlag'

const callTimelines = {
  [CALL_TIMELINE_TYPE.all]: 'getCallTimeline',
  [CALL_TIMELINE_TYPE.follower]: 'getFollowersCallTimeline',
}

export const useCallTimeline = ({ callTimeline }) => {
  const callTimelineFilters = useSelector(selectCallTimelineFilters)
  const sharedInterests = useFavFilterGrowthBookEnabled()

  const memoArg = useMemo(() => {
    return {
      ...callTimelineFilters.detail,
      categoryId: callTimelineFilters.category?.id ?? null,

      ...(callTimeline === CALL_TIMELINE_TYPE.all && {
        sharedInterests,
      }),
    }
  }, [callTimelineFilters])

  const { loadMore, shouldLoadMore, combinedResults, latestQuery, isLoading } =
    useInfiniteScrollQuery({
      memoArg,
      queryName: callTimelines[callTimeline],
      paginationKeyName: 'fromTimestamp',
      dataKey: 'posts',
    })

  const isEmptyList = useMemo(
    () => combinedResults?.length === 0,
    [combinedResults]
  )

  const onLoadMore = () => {
    loadMore(latestQuery?.data?.next_page_value)
  }

  return {
    combinedResults,
    isEmptyList,
    isLoading,
    shouldLoadMore,
    onLoadMore,
  }
}
